import React, { useMemo } from 'react';
import { AbsenceType } from '../../../__generated__/graphql';
import AbsenceAmount from './AbsenceAmount';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';

type Props = {
  type: AbsenceType;
  amount: number;
  unlimited: boolean;
  withoutBalance: boolean;
};

const i18Path = 'absences.cards.absenceCategories';

const CategoryAmount: React.FC<React.PropsWithChildren<Props>> = ({
  type,
  amount,
  unlimited,
  withoutBalance,
}) => {
  const t = useNamespacedTranslation(i18Path);

  return useMemo(() => {
    if (withoutBalance) {
      return null;
    }

    if (unlimited) {
      return <span className="time-text me-3">{t('unlimited')}</span>;
    }

    return (
      <span className="time-text me-3">
        <AbsenceAmount type={type} amount={amount} variant="normal" />
      </span>
    );
  }, [unlimited, withoutBalance, type, amount, t]);
};

export default CategoryAmount;
